export const mockTagsData = [
  {
    id: '1',
    name: 'Tag1',
    color: '#D96E2B',
    accountId: 'account1'
  },
  {
    id: '2',
    name: 'Tag2',
    color: '#3B6FE8',
    accountId: 'account2'
  },
  {
    id: '3',
    name: 'Tag3',
    color: '#9EA688',
    accountId: 'account1'
  }
];
